import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import Blog from "./SideTabPages/Blog";
import ContentPages from "./SideTabPages/ContentPages";
import Dashboard from "./SideTabPages/Dashboard";
import FAQs from "./SideTabPages/FAQs";
import ManageDiet from "./SideTabPages/ManageDietType";
import ManageIngredient from "./SideTabPages/ManageIngredient";
import ManageMealPackage from "./SideTabPages/ManageMealPackage";
import ManageEmailTemplate from "./SideTabPages/ManageEmailTemplate";
import ManageUser from "./SideTabPages/ManageUser";
import ContactUs from "./SideTabPages/ContactUs";
import ManageStaff from "./SideTabPages/ManageStaff";
import UserDetail from "./SideTabPages/ManageUser/detail";
import StaffDetail from "./SideTabPages/ManageStaff/detail";
import Recipes from "./SideTabPages/Recipes";
import RecipeDetail from "./SideTabPages/Recipes/detail";
import Settings from "./SideTabPages/Settings";
import HomepageContent from "./SideTabPages/Settings/HomepageContent";
import PromoCode from "./SideTabPages/ManagePromoCodes/index";
import ManageEquipment from "./SideTabPages/ManageEquipment";
//import OrderManagement from "./SideTabPages/OrderManagement";
import OrderManagementNew from "./SideTabPages/OrderManagementNew";
import OrderDetailNew from "./SideTabPages/OrderManagementNew/Detail";
import OrderManagementStaff from "./SideTabPages/OrderManagementStaff";
import OrderDetail from "./SideTabPages/OrderManagement/Detail";
import OrderDetailStaff from "./SideTabPages/OrderManagementStaff/Detail";
import AboutAndSustainabilityContent from "./SideTabPages/Settings/AboutAndSustainabilityContent";
import PartnershipContent from "./SideTabPages/Settings/PartnerShipAndAffiliates";
import ManagePassword from "./SideTabPages/Settings/ManagePassword";
import FaqpageContent from "./SideTabPages/Settings/FaqPageContent";
import ContactUsContent from "./SideTabPages/Settings/ContactUsContent";
import Orders from "./SideTabPages/Orders/index";
import OrderDetailSingle from "./SideTabPages/Orders/Detail";
import RefundTransaction from "./SideTabPages/RefundTransaction";
import RefundDetail from "./SideTabPages/RefundTransaction/detail";
import ManageCategory from "./SideTabPages/ManageCategory";
import SubCategory from "./SideTabPages/ManageCategory/detail";
import ManageReview from "./SideTabPages/ManageReview";
import ReviewDetail from "./SideTabPages/ManageReview/detail";
import CategoryManagement from "./SideTabPages/ManageStore/CategoryManagement/index";
import ManageProduct from "./SideTabPages/ManageStore/ManageProduct";
import ManageStoreReview from "./SideTabPages/ManageStoreReview";
import ProductsSettings from "./SideTabPages/ManageStore/ProductsSettings";
import StoreOrderManagement from "./SideTabPages/StoreOrderManagement";
import ProductSubCategory from "./SideTabPages/ManageStore/CategoryManagement/detail/ProductSubCategory";
import RatingsDetails from "./SideTabPages/ManageStoreReview/detail";
import ProductDetails from "./SideTabPages/ManageStore/ManageProduct/detail";
import StoreOrderManagementToday from "./SideTabPages/StoreOrderManagementToday";
import ManageDietary from "./SideTabPages/ManageStore/ManageDietary";
import DietaryDetail from "./SideTabPages/ManageDietary/detail";
import StoreOrderDetail from "./SideTabPages/StoreOrderManagement/Details/details";
import StoreOrderDetailToday from "./SideTabPages/StoreOrderManagementToday/Details/details";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: "/reset-password", component: <ResetPassword /> },
];

export const privateRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/product", component: <ManageProduct /> },
  { path: "/meal-package-management", component: <ManageMealPackage /> },
  { path: "/refund-transaction", component: <RefundTransaction /> },
  { path: "/refund-transaction/detail/:id", component: <RefundDetail /> },
  { path: "/email-template", component: <ManageEmailTemplate /> },
  { path: "/diet-type", component: <ManageDiet /> },
  { path: "/reviews", component: <ManageReview /> },
  { path: "/reviews/detail/:id", component: <ReviewDetail /> },
  { path: "/manage-store-review", component: <ManageStoreReview /> },
  { path: "/ingredient-management", component: <ManageIngredient /> },
  { path: "/settings", component: <Settings /> },
  { path: "/manage-user", component: <ManageUser /> },
  { path: "/manage-category", component: <ManageCategory /> },
  { path: "/manage-category/detail/:id", component: <SubCategory /> },
  { path: "/contact-us", component: <ContactUs /> },
  { path: "/manage-staff", component: <ManageStaff /> },
  { path: "/manage-user/detail/:id", component: <UserDetail /> },
  { path: "/manage-staff/detail/:id", component: <StaffDetail /> },
  { path: "/content-pages", component: <ContentPages /> },
  { path: "/faq", component: <FAQs /> },
  { path: "/recipes", component: <Recipes /> },
  { path: "/recipes/detail/:id", component: <RecipeDetail /> },
  { path: "/blogs", component: <Blog /> },
  { path: "/home-page-content", component: <HomepageContent /> },
  {
    path: "/about-and-sustainability",
    component: <AboutAndSustainabilityContent />,
  },
  { path: "/partnership-and-affiliates", component: <PartnershipContent /> },
  { path: "/change-password", component: <ManagePassword /> },
  { path: "/faq-page-content", component: <FaqpageContent /> },
  { path: "/contact-us-content", component: <ContactUsContent /> },
  { path: "/promocode", component: <PromoCode /> },
  { path: "/equipment", component: <ManageEquipment /> },
  { path: "/categoryManagement", component: <CategoryManagement /> },
  { path: "/products-settings", component: <ProductsSettings /> },
  { path: "/store-order-management", component: <StoreOrderManagement /> },
  { path: "/manage-productSubCategory/:id", component: <ProductSubCategory /> },
  { path: "/manage-StoreReviews/:id", component: <RatingsDetails /> },
  { path: "/manage-dietary", component: <ManageDietary /> },
  { path: "/manage-dietary/detail/:id", component: <DietaryDetail /> },
  { path: "/product/detail/:id", component: <ProductDetails /> },
  {
    path: "/store-order-management-today",
    component: <StoreOrderManagementToday />,
  },
  {
    path: "/store-order-details/:id/:from",
    component: <StoreOrderDetail />,
  },
  {
    path: "/store-order-details-today/:id",
    component: <StoreOrderDetailToday />,
  },

  // { path: "/order-management", component: <OrderManagement /> },
  // {
  //   path: "/order-management/detail/:id",
  //   component: <OrderDetail />,
  // },
  { path: "/order-manage", component: <OrderManagementNew /> },
  { path: "/orders", component: <Orders /> },
  {
    path: "/order-manage/detail/:id",
    component: <OrderDetailNew />,
  },
  { path: "/orders/detail/:id", component: <OrderDetailSingle /> },

  // { path: "/manage-user/add", component: <AddEditUser /> },
  // {
  //   path: "/service-provider/register",
  //   component: <RegisterServiceProvider />,
  // },
  // {
  //   path: "/service-provider/register/add",
  //   component: <AddNewServiceProvider />,
  // },
  // {
  //   path: "/service-provider/register/detail",
  //   component: <ServiceProviderDetail />,
  // },
  // {
  //   path: "/service-provider/request",
  //   component: <ServiceProviderRequest />,
  // },
  // {
  //   path: "/service-provider/request/detail",
  //   component: <NewServiceProviderRequest />,
  // },

  // {
  //   path: "/manage-service-category",
  //   component: <ManageServiceCategory />,
  // },
  // {
  //   path: "/manage-service-category/detail",
  //   component: <ManageServiceDetail />,
  // },
  // {
  //   path: "/manage-service-category/add",
  //   component: <AddEditServiceCategory />,
  // },
  // {
  //   path: "/manage-commissions",
  //   component: <ManageCommssions />,
  // },
  // {
  //   path: "/earnings",
  //   component: <Earnings />,
  // },
  // {
  //   path: "/accounting",
  //   component: <Accounting />,
  // },
  // {
  //   path: "/promocode/add",
  //   component: <AddPromoCode />,
  // },
  // {
  //   path: "/promocode/detail",
  //   component: <PromoCodeDetail />,
  // },
  // {
  //   path: "/help",
  //   component: <Help />,
  // },
  // {
  //   path: "/help/detail",
  //   component: <HelpDetail />,
  // },
  // {
  //   path: "/system-access",
  //   component: <SystemAccess />,
  // },
  // {
  //   path: "/system-access/add",
  //   component: <AddSubAdmin />,
  // },
  // {
  //   path: "/settings/edit-profile",
  //   component: <EditProfile />,
  // },
  // {
  //   path: "/settings/password",
  //   component: <ManagePassword />,
  // },
  // {
  //   path: "/faq",
  //   component: <Faq />,
  // },
  // {
  //   path: "/faq/add",
  //   component: <AddFaq />,
  // },
  // {
  //   path: "/content-page",
  //   component: <ContentPage />,
  // },
  // {
  //   path: "/content-page/add",
  //   component: <AddContentPage />,
  // },
];

export const staffRoutes = [
  // { path: "/order-management", component: <OrderManagementStaff /> },
  // {
  //   path: "/order-management/detail/:id",
  //   component: <OrderDetailStaff />,
  // },

  { path: "/orders", component: <Orders /> },
  { path: "/orders/detail/:id", component: <OrderDetailSingle /> },

  // {
  //   path: "/order-management/detail/:id",
  //   component: <OrderDetail />,
  // },
];
